export const IntegrationInboundOrderStatusColumns = {
	model: [
		{
			label: 'Status',
			key: 'status',
		},
		{
			label: 'Action',
			key: 'action'
		},
	],
	formBuilderConfig: {
		status: {
			DataType: 'String',
			DisplayText: 'Status',
			Name: 'status'
		},
		action: {
			DataType: 'Selector',
			DisplayText: 'Action',
			Name: 'action',
			UIControl: 'Dropdown',
			options: [
			],
		},
		id: {
			DataType: 'String',
			DisplayText: 'Id',
			Name: 'Id',
			hidden: true,
			required: false
		}
	}
}
